import { IoMdClose } from "react-icons/io";
import {  IoCheckmark } from "react-icons/io5";
import Modal from "../components/Modal";
const ConfirmationModal = ({
  title,
  message,
  imageSrc,
  onConfirm,
  onCancel,
  confirmText = "Yes",
  cancelText = "No",
  toggleModal,
}) => {
  return (
    <Modal toggleRemoveModal={toggleModal}>
    <div className="flex flex-col items-center justify-center">
      <div className="bg-secondary w-full h-fit p-2 px-4 py-3 rounded-t-xl rounded-tl-xl flex items-center justify-between">
        <h1 className="text-2xl text-white">{title}</h1>
        <IoMdClose
          size={30}
          color="white"
          className="cursor-pointer"
          onClick={toggleModal}
        />
      </div>
      <div className="flex flex-col items-center w-[80%] justify-center p-5 m-10 border-2 border-black border-dashed rounded-lg">
        {imageSrc && (
          <img
            src={imageSrc}
            alt="confirmation_image"
            className="w-[40%] m-5"
          />
        )}
        <p className="my-3 text-lg text-center">{message}</p>
        <div className="flex items-center justify-center w-full text-xl gap-x-4">
          <button
            className="flex items-center justify-center px-8 py-2 border-2 rounded-sm border-primary text-primary hover:bg-primary-light gap-x-2"
            onClick={onCancel}
          >
            <IoMdClose size={30} />
            <span className="font-medium">{cancelText}</span>
          </button>
          <button
            onClick={onConfirm}
            className="flex items-center justify-center px-8 py-2 text-white border-2 rounded-sm bg-primary hover:bg-primary-dark border-primary gap-x-2"
          >
            <IoCheckmark size={30} />
            <span className="font-medium">{confirmText}</span>
          </button>
        </div>
      </div>
    </div>
  </Modal>
);
};

export default ConfirmationModal;
